/** @jsxImportSource @emotion/react */
import { useFormContext, useWatch } from "react-hook-form";
import "twin.macro";
import tw from "twin.macro";

export const getShortPosition = (position) => {
  switch (position.toLowerCase()) {
    case "frontleft":
      return "FL";
    case "frontright":
      return "FR";
    case "rearleft":
      return "RL";
    case "rearright":
      return "RR";
    default:
      return "";
  }
};

const FileSelector = ({ file }) => {
  const { control, setValue, getValues } = useFormContext();

  const selectedFiles = useWatch({
    control,
    name: "selectedFiles",
    defaultValue: getValues("selectedFiles") ?? { dat: [], dxp: [] },
  });

  if (!file) return null;

  const type = file.name?.toLowerCase().endsWith(".dat") ? "dat" : "dxp";
  const checked = selectedFiles[type]?.some((f) => f.oid === file.oid) || false;

  const handleChange = () => {
    const fileObj = {
      name: file.name,
      oid: file.oid,
      file: file,
      position: getShortPosition(file.position ?? ""),
      type,
      deltaP: file.deltaP ?? 0,
      userMargins: file.userMargins,
      methodMargins: file.methodMargins,
      tirf: file.tirf,
    };

    if (type === "dat") {
      const isSelected = selectedFiles.dat.some((f) => f.oid === file.oid);
      setValue(
        "selectedFiles",
        {
          ...selectedFiles,
          dat: isSelected
            ? selectedFiles.dat.filter((f) => f.oid !== file.oid)
            : [...selectedFiles.dat, fileObj],
        },
        { shouldDirty: true },
      );
    } else {
      const isSelected = selectedFiles.dxp.some((f) => f.oid === file.oid);
      setValue(
        "selectedFiles",
        { ...selectedFiles, dxp: isSelected ? [] : [fileObj] },
        { shouldDirty: true },
      );
    }
  };

  return (
    <label
      className="group"
      onClick={(e) => e.stopPropagation()}
      css={[
        tw`flex flex-shrink items-center gap-2 text-sm border bg-opacity-50 rounded-md py-1 px-2 hover:border-gray-300 hover:bg-opacity-100 cursor-pointer`,
        checked ? tw`bg-indigo-100 border-indigo-200` : tw`bg-gray-100 border-gray-200`,
      ]}
    >
      <input
        type="checkbox"
        css={[
          tw`bg-gray-100 bg-opacity-50 z-30 ring ring-transparent ring-offset-4 ring-offset-gray-100 focus:(ring-gray-100) h-4 w-4 text-indigo-600 border-gray-300 rounded`,
          checked
            ? tw`ring-offset-indigo-100`
            : tw`ring-offset-gray-100 group-hover:border-gray-400`,
        ]}
        checked={checked}
        onChange={handleChange}
      />
      <div>{file.tirf ? `${file.name} (${file.tirf})` : file.name}</div>
    </label>
  );
};

export default FileSelector;
